export default __webpack_public_path__ + "static/media/V_Vinyl.1bc272ba.jpg";